<template>
	<div v-loading.fullscreen.lock="loading">
    <el-tabs v-model="activeName" type="card">
			<el-tab-pane label="中源协和计算" name="中源协和计算">
					<upload :quantity="currentQuantity" ref="upload" @updateLoading="updateLoading" @updateAllSize="updateAllSize" v-bind="$attrs" v-on="$listeners"></upload>
			</el-tab-pane>
      <el-tab-pane label="第三方出报告" name="第三方出报告">
        <selected  ref="selected" @updateLoading="updateLoading" @updateAllSize="updateAllSize" :quantity="currentQuantity" v-bind="$attrs" v-on="$listeners"></selected>
      </el-tab-pane>
		</el-tabs>
		<div class="operate-buttons">
			<p class="info-tip">*批量操作可能需要较长时间，请耐心等待</p>
			<el-button type="primary" @click="submit" >提 交</el-button>
			<el-button @click="close" :disabled="loading" type="primary" plain>返 回</el-button>
		</div>
	</div>
</template>
<script>
import upload from './upload'
import selected from './selected'
const packageTypeMap = {
  '中源协和计算': 'PROPRIETARY',
  '第三方出报告': 'THIRDPARTY'
}
export default {
  name: 'process-dialog',
  props: {
    quantity: {
      type: String
    }
  },
  components: {
    upload, selected
  },
  data () {
    return {
      loading: false,
      activeName: '中源协和计算'
    }
  },
  computed: {
    currentQuantity () {
      return this.quantity
    }
  },
  watch: {
    activeName (val) {
      this.$emit('updateType', packageTypeMap[val])
    }
  },
  methods: {
    submit () {
      if (this.activeName === '中源协和计算') {
        this.$refs.upload.uploadSubmit()
      } else {
        this.$refs.selected.selectedSubmit()
      }
    },
    updateLoading (val) {
      this.loading = val
      this.$emit('updateType', packageTypeMap[this.activeName])
      this.$emit('getCurrentStatusTotal')
    },
    updateAllSize (val) {
      this.$emit('updateAllSize', val)
    },
    close () {
      this.$router.push('/gene-lab-order')
    }
    // visibleHandle (val) {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', val)
    // },
    // close () {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', false)
    // },
  },
  created () {
    this.$emit('updateType', packageTypeMap[this.activeName])
  }
}
</script>
<style lang="less">
</style>
